<template>
    <div class="filters--category">
        <h4>{{ filterTitle }}</h4>
        <template v-for="filter in availableCategories">
            <div class="radio" v-bind:key="filter.id"
                 v-bind:class="{'active': selectedCategoryId === filter.id }"
                 v-on:click="onCategorySelect($event, filter)"
                 v-if="filter.counter !== 0">
                <input type="radio" name="category"
                       v-bind:id="'category-' + filter.id"
                       v-bind:value="filter.id">
                <label v-bind:for="'category-' + filter.id">{{ filter.label }}</label>
                <span class="disable" v-if="selectedCategoryId === filter.id">x</span>
                <span class="counter" v-if="!selectedCategoryId">({{ filter.counter }})</span>
            </div>
        </template>
    </div>
</template>

<script>
  export default {
    name: 'CategoryFilter',
    props: {
      availableCategories: Array,
      initialSubCategory: String,
    },
    data() {
      return {
        filterTitle: 'Categories',
        selectedCategoryId: '',
      }
    },
    watch: {
      initialSubCategory: {
        immediate: true,
        handler(val) {
          if (val) {
            this.selectedCategoryId = val;
            this.$emit('clearInitialSubCategory');
          }
        }
      }
    },
    methods: {
      onCategorySelect: function (event, category) {
        event.preventDefault();

        if (this.selectedCategoryId === category.id) {
          this.selectedCategoryId = '';
          this.$emit("clearAllFilters");
        } else {
          this.selectedCategoryId = category.id;
          const filters =  [...category.parents, category.id];
          this.$emit("applyCategoryFilters", filters);
        }
      }
    }
  }
</script>
